import { View } from 'react-native'
import styled from 'styled-components/native'

export const Separator = styled(View)`
  border: 1px solid #ececec;
  margin-top: -1px;
  margin-left: -20px;
  margin-right: -20px;
`
